import { StyleSheet } from 'react-native';
import { ONBOARDING_COLORS } from '../../src/tutorial/constants/onboardingContent.constants';

export const onboardingHeadlineStyles = StyleSheet.create({
  wrap: {
    alignItems: 'center',
    width: '100%',
  },
  title: {
    fontSize: 30,
    lineHeight: 35,
    fontWeight: '800',
    color: ONBOARDING_COLORS.textPrimary,
    textAlign: 'center',
    letterSpacing: -0.3,
  },
  subMuted: {
    fontSize: 15,
    lineHeight: 21,
    fontWeight: '500',
    color: ONBOARDING_COLORS.textSub,
    textAlign: 'center',
    marginTop: 10,
  },
  subAccentLine: {
    fontSize: 30,
    lineHeight: 35,
    fontWeight: '800',
    textAlign: 'center',
    letterSpacing: -0.3,
  },
});
